import { Button, Dropdown } from "react-bootstrap";
import "./labelmasterprofileheader.scss";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import { ReactSVG } from "react-svg";
import { useModulePermissions, PermissionModule, PermissionIdentifier } from "../../utils/permissionUtils";
import duplicatePlusIcon from "../../assets/images/duplicate-plus-icon.svg";

const LabelMasterProfileHeader = ({
  title,
  id,
  toggleModal,
  duplicateType,
}: any) => {

  const isPermitted = useModulePermissions(PermissionModule.LABEL_SETUP);
  const isEditPermitted = isPermitted(PermissionIdentifier.EDIT_LABEL_SETUP);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_LABEL_SETUP);
  const isDuplicatePermitted = isPermitted(PermissionIdentifier.DUPLICATE_LABEL_SETUP);

  return (
    <div className="patients-master-profile-header-wrapper">
      <div className="profile-title-status-box">
        <h2>{title}</h2>
      </div>
      <div className="profile-actions-box">
        {isEditPermitted && (
          <div className="edit-btn-box">
            <Button variant="primary" href={`/edit-label/${id}`}>
              <i className="bi bi-pencil-square"></i> Edit
            </Button>
          </div>
        )}
        <Dropdown>
          {(isDeletePermitted || isDuplicatePermitted) && (
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={threedotvertical}
              />
            </Dropdown.Toggle>
          )}
          <Dropdown.Menu>
            {isDuplicatePermitted && (
              <Dropdown.Item onClick={duplicateType}>
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={duplicatePlusIcon}
                />
                Duplicate
              </Dropdown.Item>
            )}
            {isDeletePermitted && (
              <Dropdown.Item onClick={toggleModal}>
                <ReactSVG className="svg-box" wrapper="span" src={deleteicon} />
                Delete
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default LabelMasterProfileHeader;
